module.exports = __webpack_public_path__ + "static/media/logo_deac.ceb433f0.png";